import imgRectangle1 from "../../../assets/102fe67ec94f35d29fe7c6b9fe35e70d1229830a.png";
import { Button } from "../ui/button";

interface BannerProps {
  handleClick: () => void;
}
const Banner = ({ handleClick }: BannerProps) => {
  return (
    <div className="bg-white py-[16px] md:py-[23px]">
      <div className="container mx-auto px-4 max-w-[1560px]">
        <div className="relative rounded-[12px] md:rounded-[17px] h-[350px] md:h-[430px] overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0 rounded-[12px] md:rounded-[17px] overflow-hidden">
            <img
              src={imgRectangle1}
              alt=""
              className="absolute w-full h-full object-cover"
              style={{
                objectPosition: "center 35%",
              }}
            />
            <div className="absolute inset-0 bg-black/55 rounded-[12px] md:rounded-[17px]" />
          </div>

          {/* Content */}
          <div className="relative h-full flex flex-col items-center justify-center text-center px-4 ">
            <div className="bg-[#ff6900] text-white px-3 py-1 rounded-full text-[10px] md:text-[12px] font-semibold leading-[16px] mb-[12px] md:mb-[16px]">
              Obligatorio desde el 30 de enero de 2026
            </div>

            <h1 className="text-white text-[32px] md:text-[50px] font-bold leading-[36px] md:leading-[44px] tracking-[-1px] mb-[10px] md:mb-[12px]">
              Nuevo Seguro de Patinetes
            </h1>

            <p className="text-white text-[14px] md:text-[18px] leading-[22px] md:leading-[28px] max-w-[672px] mb-[24px] md:mb-[32px]">
              Circula tranquilo cumpliendo la nueva normativa
              <br />
              Sencillo y al instante
            </p>
            <Button
              onClick={handleClick}
              className="bg-[#ff6900] hover:bg-[#e05f00] text-white px-6 md:px-8 h-[44px] md:h-[48px] rounded-[6px] font-bold text-[14px] md:text-[16px] leading-[20px] transition-colors"
            >
              Contratar ahora
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
